import { Quote, Star } from 'lucide-react';

export const TestimonialCard = ({ testimonial }) => {
  return (
    <div
      data-testid={`testimonial-${testimonial.id}`}
      className="bg-white border border-slate-100 rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow"
    >
      <Quote className="w-10 h-10 text-[#47ace2]/20 mb-4" />
      
      <p className="text-slate-600 font-manrope leading-relaxed mb-6">
        "{testimonial.content}"
      </p>

      <div className="flex items-center gap-1 mb-4">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
        ))}
      </div>

      <div className="flex items-center gap-4">
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div>
          <h4 className="font-semibold text-slate-900 font-outfit">{testimonial.name}</h4>
          <p className="text-sm text-slate-500 font-manrope">{testimonial.designation}</p>
          <p className="text-sm text-[#47ace2] font-manrope">{testimonial.project}</p>
        </div>
      </div>
    </div>
  );
};
